// Imports
import ownerFile from "@/base/menuStructure/menuStructureOwner";
import vehicleFile from "@/base/menuStructure/menuStructureVehicle";
import peopleFile from "@/base/menuStructure/menuStructurePeople";
import dealerFile from "@/base/menuStructure/menuStructureDealer";
import controlFile from "@/base/menuStructure/menuStructureControl";
import supportFile from "@/base/menuStructure/menuStructureSupport";
import administrationFile from "@/base/menuStructure/menuStructureAdministration";
import configurationFile from "@/base/menuStructure/menuStructureConfiguration";
import store from "@/flit2go-web-core/store/index";
import MODULE from "@/flit2go-web-core/interfaces/moduleConstants";
import CONSTANTS from "@/flit2go-web-core/interfaces/index";

// Functions
function createMenuStructure() {
  const isDealer = store.getters["auth/isOwnerDealer"];
  const isFleetControl = store.getters["auth/isOwnerFleet"];
  let menu = [];
  const modules = getRoleSchema();
  // Menu is created
  modules.forEach((module) => {
    if (module.view) {
      switch (module.code) {
        case MODULE.OWNERS.CODE:
          menu.push(
            ownerFile.getMenu(
              modules.find((item) => item.code === MODULE.OWNERS.CODE)
                .submodules,
            ),
          );
          break;
        case MODULE.VEHICLES.CODE:
          menu.push(
            vehicleFile.getMenu(
              modules.find((item) => item.code === MODULE.VEHICLES.CODE)
                .submodules,
            ),
          );
          break;
        case MODULE.PEOPLE.CODE:
          menu.push(
            peopleFile.getMenu(
              modules.find((item) => item.code === MODULE.PEOPLE.CODE)
                .submodules,
            ),
          );
          break;
        case MODULE.DEALER.CODE:
          if (isDealer) {
            menu.push(
              dealerFile.getMenu(
                modules.find((item) => item.code === MODULE.DEALER.CODE)
                  .submodules,
              ),
            );
          }
          break;
        case MODULE.CONTROL.CODE:
          if (isFleetControl) {
            menu.push(
              controlFile.getMenu(
                modules.find((item) => item.code === MODULE.CONTROL.CODE)
                  .submodules,
              ),
            );
          }
          break;
        case MODULE.SUPPORT.CODE:
          menu.push(supportFile.getMenu());
          break;
        case MODULE.ADMINISTRATION.CODE:
          menu.push(
            administrationFile.getMenu(
              modules.find((item) => item.code === MODULE.ADMINISTRATION.CODE)
                .submodules,
            ),
          );
          break;
      }
    }
  });
  // Set First link allowed
  menu.forEach((module) => {
    if (module.children.length > 0) {
      module.link = module.children[0].link;
    }
  });

  // Remove module with no childrenStyle
  menu = menu.filter(
    (module) =>
      module.children.length > 0 || module.code === MODULE.SUPPORT.CODE,
  );

  return menu;
}
function getFirstLinkAllowed() {
  const menuStructure = createMenuStructure();
  if (menuStructure.length > 0 && menuStructure[0].link) {
    return menuStructure[0].link;
  } else {
    return "/s/forbidden";
  }
}
function getRoleSchema() {
  return store.getters["auth/getUserRole"];
}
function getSidebar(moduleCode) {
  const menuStructure = createMenuStructure();
  return menuStructure.find((menu) => menu.code === moduleCode);
}
function getSidebarConfiguration() {
  const menu = [];
  const modules = getRoleSchema();
  const moduleConfiguration = modules.find(
    (module) => module.code === MODULE.CONFIGURATION.CODE,
  );
  if (moduleConfiguration.view) {
    menu.push(configurationFile.getMenu(moduleConfiguration.submodules));
  }
  return menu;
}
function hasWritePermission(submoduleCode) {
  let hasPermission = false;
  const authority = store.getters["auth/getUserAuthority"];
  const modules = getRoleSchema();

  if (
    authority === CONSTANTS.ROLE.SUPER_ADMIN ||
    authority === CONSTANTS.ROLE.MANAGER ||
    authority === CONSTANTS.ROLE.SUPER_OWNER
  ) {
    hasPermission = true;
  } else {
    modules.forEach((module) => {
      module.submodules.forEach((submodule) => {
        if (submodule.code === submoduleCode) {
          if (submodule.w) {
            hasPermission = true;
          } else {
            hasPermission = false;
          }
        }
      });
    });
  }
  return hasPermission;
}
function hasReadPermission(submoduleCode) {
  let hasPermission = false;
  const authority = store.getters["auth/getUserAuthority"];
  const modules = getRoleSchema();

  if (
    authority === CONSTANTS.ROLE.SUPER_ADMIN ||
    authority === CONSTANTS.ROLE.MANAGER ||
    authority === CONSTANTS.ROLE.SUPER_OWNER
  ) {
    hasPermission = true;
  } else {
    modules.forEach((module) => {
      module.submodules.forEach((submodule) => {
        if (submodule.code === submoduleCode) {
          if (submodule.r) {
            hasPermission = true;
          } else {
            hasPermission = false;
          }
        }
      });
    });
  }
  return hasPermission;
}

export default {
  createMenuStructure,
  getFirstLinkAllowed,
  getSidebar,
  getSidebarConfiguration,
  hasReadPermission,
  hasWritePermission,
};
